import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiSearchIcon from "@mui/icons-material/Search";
import MuiDeleteIcon from "@mui/icons-material/Delete";
import MuiTextField from "@mui/material/TextField";
import MuiFolderOpenIcon from "@mui/icons-material/FolderOpen";
import MuiFileOpenIcon from "@mui/icons-material/FileOpenOutlined";
import MuiClearIcon from "@mui/icons-material/Clear";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelInvoice from "../../model/custom/Invoice";
import ControllerInvoiceList from "../../controller/custom/InvoiceList";
import ControllerUserList from "../../controller/UserList";
import ControllerLocalization from "../../controller/Localization";
import ViewLoader from "../Loader";
import ViewPagination from "../Pagination";
import ViewDialog from "../Dialog";

let isRendered = false;

const invoiceListAutocompleteSlotProps = HelperSrc.createAutocompleteSlotProps("view_list_popper", [0, 0]);

const viewPageInvoiceList: React.FC<ModelInvoice.Iprops> = (props) => {
    // Variable
    const controllerInvoiceList = new ControllerInvoiceList(isRendered);
    const controllerUserList = new ControllerUserList(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerInvoiceList.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (
        controllerLocalization.getStorageMain &&
        controllerInvoiceList.getSelectOption &&
        controllerInvoiceList.getPagination &&
        controllerInvoiceList.getFilter &&
        controllerInvoiceList.getDataMainList
    ) {
        return (
            <div className="view_invoice_list" data-at_id="view_invoice_list">
                <table>
                    {(() => {
                        const html: JSX.Element[] = [];

                        html.push(
                            <>
                                <colgroup>
                                    <col className="cell id" />
                                    <col className="cell client" />
                                    <col className="cell filename" />
                                    <col className="cell status" />
                                    <col className="cell update_date" />
                                    <col className="cell update_by" />
                                    <col className="cell" />
                                </colgroup>
                                <thead className="filter">
                                    <tr className="row filter_action">
                                        <td>
                                            <MuiButton
                                                className="button_primary container_button"
                                                data-at_id="button_apply"
                                                disabled={controllerInvoiceList.getApiLoadingList.selectOption}
                                                onClick={() => {
                                                    controllerInvoiceList.clickFilterApply();
                                                }}
                                            >
                                                {(() => {
                                                    const html: JSX.Element[] = [];

                                                    if (controllerInvoiceList.getApiLoadingList.selectOption) {
                                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                                    } else {
                                                        html.push(
                                                            <span className="button_label">
                                                                {controllerLocalization.getStorageMain.apply} <MuiSearchIcon />
                                                            </span>
                                                        );
                                                    }

                                                    return html;
                                                })()}
                                            </MuiButton>
                                        </td>
                                    </tr>
                                    <tr className="row not_hover">
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.id}</th>
                                        <th data-at_id="th_client" className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={invoiceListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerInvoiceList.getSelectOption.client_id)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li
                                                                {...props}
                                                                data-at_id={`select_client_${option.display_name ? option.display_name : "select"}`}
                                                            >
                                                                {option.display_name || controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.client
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="client_id"
                                                            data-at_id="input_client"
                                                            defaultValue={controllerInvoiceList.getElementClientIdValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerInvoiceList.setElementClientIdValue) {
                                                        controllerInvoiceList.setElementClientIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={invoiceListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerInvoiceList.getSelectOption.file_name)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="file_name"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.file_name
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.status}</th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={invoiceListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerInvoiceList.getSelectOption.latest_update)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li className="date" {...props}>
                                                                {option.display_name
                                                                    ? HelperSrc.localeFormat(new Date(option.display_name))
                                                                    : controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="latest_update"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.latest_update
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={invoiceListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerInvoiceList.getSelectOption.user_id)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.latest_update_by
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="latest_update_by_id"
                                                            defaultValue={controllerInvoiceList.getElementLatestUpdateByIdValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerInvoiceList.setElementLatestUpdateByIdValue) {
                                                        controllerInvoiceList.setElementLatestUpdateByIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th className="cell field_container"></th>
                                    </tr>
                                </thead>
                            </>
                        );

                        return html;
                    })()}
                    <tbody data-at_id="tbody_invoice_list">
                        {(() => {
                            const html: JSX.Element[] = [];

                            if (controllerInvoiceList.getApiLoadingList.list) {
                                html.push(
                                    <tr className="row_empty">
                                        <td>
                                            <MuiCircularProgress className="icon_progress" />
                                        </td>
                                    </tr>
                                );
                            } else {
                                if (!controllerInvoiceList.getPagination || Object.entries(controllerInvoiceList.getPagination.data).length === 0) {
                                    html.push(
                                        <tr className="empty_state">
                                            <td colSpan={100}>
                                                <MuiFolderOpenIcon className="icon" />
                                                <p>{controllerLocalization.getStorageMain.no_result}</p>
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    for (const [key, data] of Object.entries(controllerInvoiceList.getDataMainList)) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        let clientDisplayName = "";

                                        for (const optionData of Object.values(controllerInvoiceList.getSelectOption.client_id)) {
                                            if (optionData.value === data.client_id) {
                                                clientDisplayName = optionData.display_name;
                                            }
                                        }

                                        let statusDisplayName = "";

                                        for (const optionData of Object.values(controllerInvoiceList.getSelectOption.status_id)) {
                                            if (optionData.value === data.status_id) {
                                                statusDisplayName = optionData.display_name;
                                            }
                                        }

                                        html.push(
                                            <tr
                                                className={`row ${alternateRow}`}
                                                data-at_id={`tr_list_data_${data.id}`}
                                                onClick={(event) => {
                                                    controllerInvoiceList.clickItem(event, data);
                                                }}
                                            >
                                                <td className="cell">{data.id}</td>
                                                <td className="cell" data-at_id="td_client_name">
                                                    {clientDisplayName}
                                                </td>
                                                <td className="cell" data-at_id="td_file_name">
                                                    <MuiFileOpenIcon
                                                        data-at_id="icon_show"
                                                        className="preview_icon"
                                                        onClick={(event) => controllerInvoiceList.clickShow(event, data.id)}
                                                    />
                                                    {data.file_name}
                                                </td>
                                                <td className="cell" data-at_id="td_status">
                                                    {statusDisplayName}
                                                </td>
                                                <td className="cell">
                                                    {data.latest_update ? HelperSrc.localeFormat(new Date(data.latest_update)) : ""}
                                                </td>
                                                <td className="cell">
                                                    {(() => {
                                                        for (const optionData of Object.values(controllerInvoiceList.getSelectOption.user_id)) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            if (data.latest_update_by_id === optionDataTyped.value) {
                                                                return optionDataTyped.display_name;
                                                            }
                                                        }
                                                    })()}
                                                </td>
                                                <td className="cell center">
                                                    {(() => {
                                                        const html: JSX.Element[] = [];

                                                        if (
                                                            HelperSrc.checkRole(
                                                                controllerUserList.getStorageRole,
                                                                ["superuser", "manager"],
                                                                props.userData
                                                            ) &&
                                                            data.status_id < 7
                                                        ) {
                                                            html.push(
                                                                <MuiDeleteIcon
                                                                    data-at_id="icon_delete"
                                                                    className="button_icon"
                                                                    onClick={(event) => controllerInvoiceList.clickRemove(event, data.id)}
                                                                />
                                                            );
                                                        }

                                                        return html;
                                                    })()}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }
                            }

                            return html;
                        })()}
                    </tbody>
                </table>
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerInvoiceList.getApiLoadingList.previewFile !== undefined) {
                        if (controllerInvoiceList.getApiLoadingList.previewFile) {
                            html.push(
                                <div className="right">
                                    <MuiCircularProgress className="icon_progress_absolute" />
                                </div>
                            );
                        } else {
                            html.push(
                                <div className="right">
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        if (controllerInvoiceList.getUrlFile) {
                                            html.push(
                                                <div className="content_preview">
                                                    <MuiButton
                                                        data-at_id="icon_close"
                                                        className="button_primary"
                                                        onClick={() => controllerInvoiceList.clickClose()}
                                                    >
                                                        <MuiClearIcon />
                                                    </MuiButton>
                                                    <embed data-at_id="pdf_preview" className="pdf_preview" src={controllerInvoiceList.getUrlFile} />
                                                </div>
                                            );
                                        }

                                        return html;
                                    })()}
                                </div>
                            );
                        }
                    }

                    return html;
                })()}
                <ViewPagination response={controllerInvoiceList.getPagination} api={controllerInvoiceList.apiDataList} />
                <ViewDialog
                    className="invoice_remove_dialog"
                    isOpen={controllerInvoiceList.getIsDialogOpen}
                    isApiLoading={controllerInvoiceList.getApiLoadingList.removeData as boolean}
                    labelConfirm={controllerLocalization.getStorageMain.yes}
                    onClickConfirm={controllerInvoiceList.clickDialogRemoveConfirm}
                    labelCancel={controllerLocalization.getStorageMain.no}
                    onClickCancel={controllerInvoiceList.clickDialogRemoveCancel}
                    mode={"alert"}
                    content={controllerLocalization.getStorageMain.delete_record}
                />
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageInvoiceList;
